
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import FormField from "../../base_classes/FormField"

import SelectGroupDialog from "../dialogs/SelectGroupDialog.vue"
import GroupQuery from "../../graphql/group/group.graphql"
import * as cdn from "@coredination/components"

@Component({
    apollo: {
        me: cdn.graphql.me,
        group: {
            query: GroupQuery,
            skip() {
                if (this.me && !this.value.groupUuid) this.value.groupUuid = this.me.primaryGroupUuid
                return this.value.groupName || !this.value.groupUuid
            },
            variables() {
                return { uuid: this.value.groupUuid }
            },
        },
    },
    components: { SelectGroupDialog },
})
export default class GroupField extends FormField {
    @Prop() errorRequired!: boolean
    selecting: boolean = false

    group: any = {}
    me: any = null

    onClick() {
        if (this.editable) {
            this.selecting = true
        } else {
            console.warn("Group is not editable")
        }
    }

    onClear() {
        this.value.groupName = null
        this.value.groupUuid = null
        this.$emit("input", this.value)
    }

    select(group: any) {
        const original = this.value && this.value.groupUuid
        this.selecting = false
        if (group.uuid != this.value.groupUuid || group.name != this.value.groupName) {
            Vue.set(this.value, "groupName", group.name)
            Vue.set(this.value, "groupUuid", group.uuid)
            if (this.errorRequired) this.$emit("clearErrorRequired", "group")
            this.$emit("input", this.value)
            if (original != this.value.groupUuid) this.$emit("change", this.value)
        }
    }

    get groupName() {
        var groupName: string =
            this.value && this.value.groupName
                ? this.value.groupName
                : this.group && this.group.name
                ? this.group.name
                : ""
        return groupName
    }

    get loading() {
        return this.$apollo.queries.me.loading || this.$apollo.queries.group.loading
    }
}
